import { useQuery } from 'react-query';
import { CustomerAgreementsApi } from '../CustomerAgreementsApi';
import { CustomerAgreementQueryKey } from '../queryKeys';
import { CustomerAgreement } from '../types';

export function useCustomerAgreementQuery(id: number | null) {
    return useQuery<CustomerAgreement>(
        [CustomerAgreementQueryKey, id],
        () => CustomerAgreementsApi.getCustomerAgreement(id as number),
        { enabled: id !== null, cacheTime: 0, refetchOnWindowFocus: false }
    );
}
